export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "talk-JitsiStreamBackgroundEffect.worker.worker.js?v=4d358095e4c459df9230");
}
